module.exports = "https://cwa.roocdn.com/_next/static/restaurants.2a02d1a0.jpg";